import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Stack, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { ConditionField, ItemDataType } from "../../../../api/biClient.types.ts";
import { useSharedReportingLocalization } from "../../../../hooks/useSharedReportingLocalization.ts";
import LinkIcon from "../../../../icons/LinkIcon.tsx";
import AreaFieldItem from "../fields/areaFields/AreaFieldItem.tsx";
import { AreaFieldItemDetailed } from "../fields/areaFields/AreaFieldItemDetailed.tsx";
import { FieldItemProps } from "../fields/areaFields/areaFiledItem.types.ts";
import ConditionMarker from "./ConditionMarker.tsx";

interface Props extends FieldItemProps<ConditionField> {
  detailedView: boolean;
  marked?: boolean;
  linked?: boolean;
  invalid?: boolean;
}

const ConditionItem = ({
  detailedView,
  marked,
  linked,
  invalid,
  field,
  canBeRemoved,
  readonly,
  onRemoveItem,
  formatCaption,
  onShowOptions: showOptions,
  autoShowItemOptionsId,
  onSetAutoShowItemOptionsId,
}: Props) => {
  const { report: locale } = useSharedReportingLocalization();
  const [ref, setRef] = useState<HTMLElement | null>(null);

  const isCrossFilterToBeRefreshed = React.useMemo(() => {
    return !field.crossFilter?.loading && field.crossFilter?.toRefresh === true;
  }, [field.crossFilter]);

  const shouldOptionsBeHidden = React.useMemo(() => {
    if (!readonly) {
      return false;
    }
    return field.meta.type === ItemDataType.Date || field.meta.type === ItemDataType.Numeric;
  }, [field.meta.type, readonly]);

  return (
    <>
      {marked && <ConditionMarker />}
      <Stack
        sx={{
          flexDirection: "row",
          flex: 1,
          display: "flex",
          width: "100%",
          alignItems: "center",
        }}
      >
        {linked && <LinkIcon sx={{ pl: 1 }} />}
        {invalid && (
          <Tooltip title={locale.condition_warning}>
            <ErrorOutlineIcon color="secondary" sx={{ ml: 1 }} />
          </Tooltip>
        )}
        <AreaFieldItem
          field={field}
          canBeRemoved={canBeRemoved}
          readonly={readonly}
          isLoading={
            field.crossFilter?.loading === true ||
            field.dictionary?.loading === true ||
            isCrossFilterToBeRefreshed === true
          }
          hideOptions={shouldOptionsBeHidden}
          onRemoveItem={onRemoveItem}
          formatCaption={formatCaption}
          onShowOptions={showOptions}
          optionRef={setRef}
          autoShowItemOptionsId={autoShowItemOptionsId}
          onSetAutoShowItemOptionsId={onSetAutoShowItemOptionsId}
        />
      </Stack>

      {detailedView && (
        <AreaFieldItemDetailed
          field={field}
          onShowOptions={() => showOptions?.call(null, { field, ref, showOnlySelected: true })}
        />
      )}
    </>
  );
};

export default ConditionItem;
